
export function createNodesCopies(nodes, connectedLinks, linkMap) {
    const copiedNodes = [];
    const copiedLinks = [];
    const copiedLinkMap = new Map();

    if (nodes !== undefined && connectedLinks !== undefined && linkMap !== undefined) {
        nodes.forEach(n => copiedNodes.push(n))
        connectedLinks.forEach(n => copiedLinks.push(n))
        linkMap.forEach((value, key) => copiedLinkMap.set(key, value));
        return {copiedNodes, copiedLinks, copiedLinkMap}
    }
}